import { useGetCartQuery, useGetLightCartQuery } from '@/redux/api/client/cart';

interface MyCartProps {
  context: 'panel' | 'page';
}

const MyCart = (props: MyCartProps) => {
  const { data: cartData } = useGetCartQuery();
  const { data: lightCart } = useGetLightCartQuery();

  return (
    <div className="container">
      <h1 className="heading-1">My Cart ({lightCart?.extendedQuantity ?? 0})</h1>
      <h2>placeholder component, context: {props.context}</h2>
      <p className="text-1">
        This should be a shared component for CartPanel and CartPage UI/logic. Use the 'context'
        prop for any visual or behavioral differences between the Cart Panel and Cart Page
      </p>
      <pre>{JSON.stringify(cartData, null, 2)}</pre>
    </div>
  );
};

export default MyCart;
